import { CENTER, REPORT } from "../constants/mainAPI";
import { ErrorResponseType, PageSearch } from "../types/api/main";
import { ReportCreate, ReportSearch, ReportsSuccessResponse, ReportSuccessResponse } from "../types/api/report";
import { toFormData } from "../utils/toFormData";
import { doDeleteRequest, doGetRequest, doPostRequest, doPutRequest } from "./mainAPI";

export const getReports = (
    centerId: number | undefined,
    callback?: (resp: ReportsSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
    searchParams?: ReportSearch & PageSearch,
) => {
    return doGetRequest(`${CENTER}/${Number(centerId)}/${REPORT}`, true, searchParams, callback, errorCallback);
};

export const getReport = (
    centerId: number | undefined,
    reportId: number | undefined,
    callback?: (resp: ReportSuccessResponse) => any,
    errorCallback?: (resp: any) => void,
) => {
    return doGetRequest(
        `${CENTER}/${Number(centerId)}/${REPORT}/${Number(reportId)}`,
        true,
        {},
        callback,
        errorCallback,
    );
};

export const createNewReport = (
    centerId: number | undefined,
    data: ReportCreate,
    callback?: (resp: ReportSuccessResponse) => void,
    errorCallback?: (resp: ErrorResponseType<any>) => void,
) => {
    const formData = toFormData(data);
    // TODO: костыль чтобы могли создать отчет, а потом через редактирование его заполнить
    formData.append("info[]", "");

    return doPostRequest(`${CENTER}/${Number(centerId)}/${REPORT}`, true, formData, {}, callback, errorCallback);
};

export const editReport = (
    centerId: number | undefined,
    reportId: number | undefined,
    data: ReportCreate,
    callback?: (resp: ReportSuccessResponse) => void,
    errorCallback?: (resp: any) => void,
) => {
    const formData = toFormData(data);

    return doPutRequest(
        `${CENTER}/${Number(centerId)}/${REPORT}/${Number(reportId)}`,
        true,
        formData,
        {},
        callback,
        errorCallback,
    );
};

export const deleteReport = (
    centerId: number | undefined,
    reportId: number | undefined,
    callback?: (resp: any) => void,
    errorCallback?: (resp: any) => void,
) => {
    return doDeleteRequest(
        `${CENTER}/${Number(centerId)}/${REPORT}/${Number(reportId)}`,
        true,
        {},
        callback,
        errorCallback,
    );
};
